import { render, staticRenderFns } from "./EditDocuments.vue?vue&type=template&id=7c5a9cfa&scoped=true&lang=html"
import script from "./EditDocuments.vue?vue&type=script&lang=js"
export * from "./EditDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5a9cfa",
  null
  
)

export default component.exports